<mat-expansion-panel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
        <span class="sid-graph--panel--title">Self Identified Deviations</span>
      </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="sid-graph--panel">
    <div class="sid-graph--title">
      <span>Status Summary for {{ date | date:dateFormat}}</span>
    </div>

    <div class="sid-graph--panel--buttons">
      <button mat-mini-fab color="accent" (click)="refresh()">
        <mat-icon>autorenew</mat-icon>
      </button>
      <a routerLink="/sid/add"><button mat-raised-button color="primary" class="sid-graph--panel--add-btn">+ Add SID</button></a>
    </div>
  <span class="sid-graph--panel--sid-title">SIDs: {{count(data?.sids)}}</span>
    <div class="sid-graph--panel--sid" *ngIf="data?.sids">
      <canvas #sidGraph baseChart width="100%" height="100%" [data]="data?.sids" [labels]="sidLabels"
        [chartType]="doughnutChartType" [options]="sidOptions">
      </canvas>
    </div>
    <span class="sid-graph--panel--capa-title">CAPA/ECs: {{count(data?.capas)}}</span>
    <div class="sid-graph--panel--capa" *ngIf="data?.capas">
      <canvas #capaGraph baseChart width="100%" height="100%" [data]="data.capas" [labels]="capaLabels"
        [chartType]="doughnutChartType" [options]="capaOptions">
      </canvas>
    </div>
  </div>
</mat-expansion-panel>